import Controller from "./controller";

let LobbyController = new Controller();

export {
    LobbyController
}
